$(document).ready(function () {
    // form contact
    //jcf.destroy('#inputselectindicatif');
    function checkFormContact() {
        var val = true;
        $('#contact-form .veriform').each(function (index) {

            if ($(this).val() === '') {
                val = false;
            }
        });

        return val;
    }

    $('#clickPhone').click(function () {

        var tel = $(this).data('tel'), phone = $(this).data('phone'), appointment = $(this).data('appointment'),
            popupTitle = $(this).data('popup-title'), popupRdv = $(this).data('popup-rdv'), popupCall = $(this).data('popup-call');

        Swal.fire({
            title: '<strong>' + popupTitle + '</strong>',
            icon: 'info',
            html:
                '<div style="font-size: 20px">' +
                '<a style="color: #DB3056;text-decoration: underline" href="' + appointment + '" target="_blank">' + popupRdv + '</a> ' +
                popupCall + '  <a style="color: #DB3056;text-decoration: underline" href="tel:' + tel + '">' + phone + '</a></div>',
            showCloseButton: false,
            showCancelButton: false,
            focusConfirm: false
        });
        return false;

    });

    $('#sendformcontact').click(function () {

        var val = checkFormContact();

        if (val) {
            $.post("/ajax-contact-form", $("#contact-form").serialize()).done(function (data) {
                $('#contact-form .veriform').val('');

                Swal.fire(
                    'Votre message est envoyé !',
                    'Cliquez sur Ok pour revenir à la page.',
                    'success'
                );
            });
        } else {
            Swal.fire({
                icon: 'error',
                title: 'Formulaire incomplet',
                text: 'Merci de remplir tous les champs.'
            });
        }

        return false;
    });

    //globalong-goto
    $('.globalong-goto').click(function () {
        if (screen.width > 700) {
            var hrefLink = $(this).attr('href');
            window.location.href = hrefLink;
        }
    });

    $(".sticky-glob").sticky({topSpacing: 111});

    $(".sticky-glob-click a").click(function () {
        $('html, body').animate({scrollTop: $('#stick-zone-glob').offset().top}, 'slow');
    });

    // end

    // fermeture du menu après le clic contact
    $('#contact-glob-go').click(function () {
        $('#nav').collapse('hide');
    });

    // Mini filtre
    $("#filtre-paysejour").change(function () {

        $('#filtre-langue').html('<option value="" selected>CHOISIR LA LANGUE</option>');
        $('#filtre-typesejour').html('<option value="" selected>CHOISIR LE PROGRAMME</option>');
        $('#filtre-langue').prop('disabled', 'disabled');
        $('#filtre-typesejour').prop('disabled', 'disabled');

        var idPaySejour = $('#filtre-paysejour').find(":selected").attr('data-id');

        $.get("/apisite/minfilter/langues?idPaysSejour=" + idPaySejour, function (data) {

            var data_length = data.length;
            var htmlOutPut = '<option value="" selected>CHOISIR LA LANGUE</option>';

            //typeSejour-6-90
            for (var i = 0; i < data_length; i++) {
                htmlOutPut += '<option data-idlib="' + data[i]['idLib'] + '" value="langue-' + data[i]['idType'] + '-' + data[i]['idLib'] + '">' + data[i]['lib'] + '</option>';
            }

            $('#filtre-langue').html(htmlOutPut);
            $('#filtre-langue').prop('disabled', false);
            $('#filtre-typesejour').prop('disabled', false);
            jcf.refreshAll();
        });

    });

    $("#filtre-langue").change(function () {
        var idPaySejour = $('#filtre-paysejour').find(":selected").attr('data-id');
        var idLibLangue = $('#filtre-langue').find(":selected").attr('data-idlib');

        $.get("/apisite/minfilter/type-programmes?idPaysSejour=" + idPaySejour + "&idLibLangue=" + idLibLangue, function (data) {

            var htmlOutPut = '<option value="" selected>CHOISIR LE PROGRAMME</option>';

            const dataArr = Object.values(data);
            for (var i = 0; i < dataArr.length; i++) {
                htmlOutPut += '<option value="typeSejour-' + dataArr[i]['idType'] + '-' + dataArr[i]['idLib'] + '">' + dataArr[i]['lib'] + '</option>';
            }
            $('#filtre-typesejour').html(htmlOutPut);
            jcf.refreshAll();
        });
    });

    $(document).on("click", "#copy-shortcut", function () {
        $('#copy-shortcut-div').show();
    });

    // ==== filtre V2 ====
    // Initialisation du filtre
    sessionStorage.removeItem('filtrev2-submit');
    sessionStorage.removeItem('filtrev2-pays');
    sessionStorage.removeItem('filtrev2-langue');
    sessionStorage.removeItem('filtrev2-typesejour');

    /**
     *  Gestion du select
     */
    $(document).on("change", ".select-filter-glob", function () {
        // Sauvegarde des choix pour le select
        var idSelect = $(this).attr('id');
        var selectValue = $(this).val();
        sessionStorage.setItem(idSelect, selectValue);
        sessionStorage.setItem('filtrev2-submit', true);

        const typeFiltre = $(this).attr('data-select-type');
        $('#type-clic').val(typeFiltre);

//        $('#filter-btn').html('<i class="fa fa-circle-o-notch fa-spin fa-lg fa-fw"></i>');
        $("#loaderFinish").addClass('hide');
        $('#loadfilter').removeClass('hide');

        $('#filter-btn-cancel').removeClass('hide');

        $.post("/tree/idsok", $('#filtre-v2-form').serialize())
            .done(function (data) {
                loadSelectFiltre('filtrev2-pays', data.libValideByCat.pays);
                loadSelectFiltre('filtrev2-langue', data.libValideByCat.langue);
                loadSelectFiltre('filtrev2-typesejour', data.libValideByCat.type);
                $('#filter-btn').html($('#filter-btn').attr('data-default-label') || 'Valider');
                $("#loaderFinish").removeClass('hide');
                $('#loadfilter').addClass('hide');
            });
    });

    /**
     *  Traitement des options du select
     * @param idSelect
     * @param dataLib
     */
    function loadSelectFiltre(idSelect, dataLib) {
        var selectOptions = '<option value="">Choisir</option>';
        const types = dataLib;
        const typesValues = Object.values(types);
        typesValues.forEach(function (v) {
                var selected = '';
                var dataSelectSession = sessionStorage.getItem(idSelect);
                if (dataSelectSession != null && dataSelectSession == v.id) {
                    selected = 'selected';
                }
                selectOptions += '<option value="' + v.id + '" ' + selected + '>' + v.lib + '</option>';
            }
        );
        $('#' + idSelect).html(selectOptions);
    }

    $(document).on("click", "#filter-btn-cancel", function () {
        sessionStorage.removeItem('filtrev2-submit');
        sessionStorage.removeItem('filtrev2-pays');
        sessionStorage.removeItem('filtrev2-langue');
        sessionStorage.removeItem('filtrev2-typesejour');

        $.get("/ajax-filter-formv2", function (data) {
            $('#zone-filter-select-travel').html(data);
            jcf.replaceAll();
        });
    });

    // Pour le select du formulaire
    if (typeof jcf !== 'undefined' && jcf.destroy) {
        jcf.destroy('#inputselectindicatif');
    }
});